import {h} from 'ui/Framework';

export default h('svg', {
  width: '30',
  height: '31',
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '-1 -1 32 33'
}, [
  h('path', {
    fill: '#EEF2F4',
    d: 'M20-.1c2.3 0 4.4 1 5.9 2.5 1.3 1.3 3.4 1.3 4.7 0 1.3-1.3 1.3-3.5 0-4.8-2.7-2.7-6.5-4.4-10.6-4.4S12.1-5.1 9.4-2.3a3.32 3.32 0 0 0 0 4.7c1.3 1.3 3.4 1.3 4.7 0C15.6.9 17.7-.1 20-.1zm5.9 2.5c1.5 1.6 2.5 3.7 2.5 6.1 0 2.4-.9 4.5-2.5 6.1-1.3 1.3-1.3 3.5 0 4.8 1.3 1.3 3.4 1.3 4.7 0 2.7-2.8 4.4-6.6 4.4-10.9S33.3.4 30.6-2.4a3.32 3.32 0 0 0-4.7 0c-1.3 1.4-1.3 3.5 0 4.8'
  }),
  h('path', {
    fill: '#E0534E',
    d: 'M25.9 14.6c-1.5 1.6-3.6 2.5-5.9 2.5-2.3 0-4.4-1-5.9-2.5a3.32 3.32 0 0 0-4.7 0c-1.3 1.3-1.3 3.5 0 4.8a14.731 14.731 0 0 0 21.2 0c1.3-1.3 1.3-3.5 0-4.8a3.32 3.32 0 0 0-4.7 0'
  }),
  h('path', {
    fill: '#FAEC28',
    d: 'M14.1 14.6c-1.5-1.6-2.5-3.7-2.5-6.1 0-2.4.9-4.5 2.5-6.1 1.3-1.3 1.3-3.5 0-4.8a3.32 3.32 0 0 0-4.7 0C6.7.4 5 4.3 5 8.5s1.7 8.1 4.4 10.9c1.3 1.3 3.4 1.3 4.7 0 1.3-1.3 1.3-3.5 0-4.8'
  }),
  h('path', {
    fill: '#BE433B',
    d: 'M14.1 14.6a3.32 3.32 0 0 0-4.7 0c-1.3 1.3-1.3 3.5 0 4.8 1.3 1.3 3.3 1.3 4.6 0 1.4-1.3 1.4-3.5.1-4.8z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/paywall-planplus.es6.js